import React from 'react';

import { Box } from '@mui/system';

const AcContentWrapper = ({
  children,
  className,
  customStyle={}
}: {
  children: React.ReactNode;
  className?: string;
  customStyle?: Record<string, string | number>
}) => {
  return (
    <Box className={className + ' content-wrapper'} px={'3rem'} sx={{...customStyle}}>
      {children}
    </Box>
  );
};

export default AcContentWrapper;
